// src/theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary:{
      main: '#065187',
    },

    background: {
        default: '#f5f5f5',
    },
    text: {
      primary: '#333333', // Dark grey for primary text
      secondary: '#ffffff', // Slightly lighter grey for secondary text
    },
  },
  typography: {
    fontFamily: '"Arial", sans-serif',
    allVariants: {
      color: '#333333', // Ensure all text defaults to dark grey
    },
  },
});

export default theme;
